import { Injectable } from '@angular/core';
import {
  DEFAULT_OPACITY,
  DEFAULT_RASTER_OPACITY,
  LayerSettingsState2D,
} from '../../../cross-team-shared/state/layer-settings-state-2d';
import { AbstractLayerSettingsService } from '../../../cross-team-shared/toolbars/layer-settings/abstract-layer-settings.service';
import { ImageContentStore } from '../state/image-content-store';

@Injectable()
export class ImageLayerSettingsService extends AbstractLayerSettingsService<
  ImageContentStore,
  LayerSettingsState2D
> {
  protected override getDefaultSettings() {
    const opacity =
      this.store.state().output.meta.layer_type === 'raster_coding'
        ? DEFAULT_RASTER_OPACITY
        : DEFAULT_OPACITY;
    return new LayerSettingsState2D(opacity);
  }
}
